// @flow
import React from 'react';
import {Link} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Widget from 'app/components/Widget';
import Category from 'app/components/Category';
import Image from 'app/components/Image';
import styles from './WidgetAuthors.styles';
import api from 'utils/API';

class WidgetAuthors extends React.Component<Props> {
  unmounted = false;

  constructor(props) {
    super(props);

    this.state = {
      list: []
    };
  }

  componentDidMount() {
    api.post('/pages/authors')
    .then(response => {
      if (this.unmounted) {
        return;
      }

      const list = response.data.list || [];
      this.setState({list});
    });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const {classes} = this.props;

    return (
      <Widget title="نویسندگان">
        <ul className={classes.list}>
          {this.state.list.map(item => {
            return (
              <li key={item.post.name} className={classes.item}>
                <Grid container>
                  <Grid item xs={2} sm={1} md={2}>
                    <Link to={`/author/${item.uname}`}>
                      <Image src={item.image} border circle />
                    </Link>
                  </Grid>
                  <Grid item xs={10} sm={11} md={10}>
                    <Link
                      to={`/${item.post.name}`}
                      className={classes.title}
                    > {item.post.title} </Link>
                    <div className="details">
                      <Category
                        id={item.post.category.id}
                        name={item.post.category.name}
                        slug={item.post.category.slug}
                      />
                      | 
                      <Link
                        to={`/author/${item.uname}`}
                        className={classes.author}
                      > {item.name} </Link>
                    </div>
                  </Grid>
                </Grid>
              </li>
            );
          })}
        </ul>
      </Widget>
    );
  }
}

const Component = withStyles(styles)(WidgetAuthors);
export {Component as WidgetAuthors};